// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"a6d204e3","300":"a6d204e3","739":"a6d204e3","849":"a6d204e3","922":"a6d204e3","994":"f40fe96a"}[chunkId] + ".chunk.css";
};